export const getSubmitError = (
  errorMessage: string,
  songs?: Array<{ title: string; writers: string }>,
  serverErrors?: Record<string, string[]>,
): { formattedMessage: string; validationErrors: Record<string, string[]> } => {
  const validationErrors: Record<string, string[]> = {}

  if (serverErrors) {
    Object.assign(validationErrors, serverErrors)
  } else {
    const formatted = errorMessage
      .replace(/^Validation failed\s*/, '')
      .replace(/^Validation errors:\s*/, '')

    formatted.split(',').forEach(errorItem => {
      const trimmedError = errorItem.trim()

      if (trimmedError.includes(':')) {
        const [field, message] = trimmedError.split(':').map(part => part.trim())
        validationErrors[field] = [message]
      }
    })
  }

  const displayErrors: string[] = []
  Object.entries(validationErrors).forEach(([field, messages]) => {
    const songMatch = field.match(/^song_(\d+)_(.+)$/)
    if (songMatch) {
      const songIndex = parseInt(songMatch[1], 10)
      const song = songs?.[songIndex]
      const songTitle = song?.title || `Song ${songIndex + 1}`
      const songWriter = song?.writers ? ` by ${song.writers}` : ''

      messages.forEach(message => {
        displayErrors.push(`• ${songTitle}${songWriter}: ${message}`)
      })
    } else {
      const cleanField = field.replace(/_/g, ' ')
      const capitalizedField = cleanField.replace(/\b\w/g, l => l.toUpperCase())
      messages.forEach(message => {
        displayErrors.push(`• ${capitalizedField}: ${message}`)
      })
    }
  })

  return {
    formattedMessage: displayErrors.join('\n'),
    validationErrors,
  }
}
